import { FC, useState } from "react"

import { useTranslation } from "react-i18next"

import { SingleOptTimeRangePicker } from "components/date/SingleOptTimePeriodPicker"
import { TopBar } from "components/navigation/TopBar"
import { SearchInput } from "components/search/SearchInput"
import { Table } from "components/tables/Table"

import { tableActivityColumns } from "constants/activity"

import { activityService } from "services/activity/activity.service"

export const Activity: FC = () => {
  const { t } = useTranslation(["translation"], { useSuspense: false })

  const [query, setQuery] = useState<string>("")
  const [timeframe, setTimeframe] = useState<(Date | null)[]>([])

  const handleChangeTimeFrame = (dates: (Date | null)[]) => setTimeframe(dates)

  return (
    <div className="grid w-full gap-8 p-8 pt-0 grid-col-1">
      <TopBar title={t("activity.title")} />
      <div className="flex flex-row items-end justify-between z-50">
        <div className="flex gap-4">
          <div className="max-w-sm">
            <SearchInput placeholder={t("form.searchUsernameEmail")} onChange={setQuery} />
          </div>
          <div className="max-w-md z-20">
            <SingleOptTimeRangePicker onTimeframeChange={handleChangeTimeFrame} noLabel />
          </div>
        </div>
      </div>
      <Table
        title={t("activity.title")}
        handler={activityService.getAdminActivity}
        columns={tableActivityColumns}
        filters={{ q: query, createdAt: timeframe }}
      />
    </div>
  )
}
